import React from 'react';
import Text from '../../elements/Text';
import Popup from '../../elements/Popup';
import Button from '../../elements/Button';
import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import {tID} from '../../../utils/TestIdHelper';

const EligibilityStatusModal = ({visible, onPressClose = () => {}}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <Popup
      visible={visible}
      title="Benefits Change"
      testID={'EligibilityStatusModal-Popup-Main'}
      textAlign="center"
      description={
        <>
          It looks like your benefits with your employer may have changed. If
          this seems incorrect please reach out to them. In the meantime you
          will have{' '}
          <Text variation="Body1SemiBold" color={colors.textMuted}>
            limited access
          </Text>{' '}
          to the app until the 1st of the upcoming month. On the 1st of the
          month you will{' '}
          <Text variation="Body1SemiBold" color={colors.textMuted}>
            no longer have access.
          </Text>
        </>
      }>
      <Button
        testID={tID('EligibilityStatusModal-Button-Close')}
        style={styles.button}
        onPress={onPressClose}
        title={'Close'}
      />
    </Popup>
  );
};

export default EligibilityStatusModal;
